import React, { useState } from 'react';
import './found-collaborator-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';

const FoundCollaboratorModal = ({
  show,
  cancel,
  collabProfile,
  confirm,
  loading
}) => {

  const [ role, setRole ] = useState(null);

  return (
    <div className="found-collaborator-modal">
      <Modal
        show={show}
        cancel={cancel}
        text="Potential Collaborator Found!"
        closeButton={true} >
        <div className="modal-content">
          <p>
            A user with the email <b>{collabProfile && collabProfile.email}</b> has been found. 
            Would you like to invite them as a collaborator?
          </p>
          {/* <div className="g-space-1"></div> */}
          {/* {
            (collabProfile && collabProfile.appId) &&
            <div className='found-user'>
              <UserIcon profile={collabProfile ? collabProfile : {}} />
              {collabProfile.fName} {collabProfile.lName} 
            </div>
          } */}
          <div className='g-space-1'></div>
          <div className='field small'>
            <label>Choose a Role for this collaborator</label>
            <select 
              id='collab-role-select'
              value={role ?? ''}
              onChange={(e) => setRole(e.target.value)}>
              <option value="">Choose a role...</option>
              <option value="manager">Game Manager</option>
              <option value="distributor">Distributor</option>
            </select>
          </div>
          <div className="g-space-2"></div>
          {
            loading
            ?
            <div className='buttons'>
              <button className='g-button'>Cancel</button>
              <button className='g-button' disabled>
                <ThreeDotsLoader />
              </button>
            </div>
            :
            <div className="buttons">
              <button 
                className="g-button" 
                onClick={cancel}>
                Cancel
              </button>
              <button 
                className={`g-button ${collabProfile && role ? 'primary' : 'disabled'}`} 
                onClick={() => confirm(role)}>
                Invite Collaborator
              </button>
            </div>
          }
        </div>    
      </Modal>
    </div>
  )
}

export default FoundCollaboratorModal